<template>
  <!-- MBR035/MBR036 voucher detail sheet — member_app_UI/song_fa_members_voucher_detail -->
  <div
    class="modal modal-bottom fade"
    id="qrcode-modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="qrcode-modal"
    style="z-index: 10000"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content mbr-voucher">
        <div class="mbr-voucher__top">
          <span class="mbr-voucher__handle" aria-hidden="true"></span>
          <!-- keep .btn-close: views close every open sheet with $(".btn-close").click() -->
          <button
            type="button"
            class="btn-close mbr-voucher__close"
            data-bs-dismiss="modal"
            :aria-label="$t('common.close')"
          >
            <svg fill="none" stroke="currentColor" stroke-width="2.2" viewBox="0 0 24 24" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
          </button>
        </div>

        <div class="mbr-voucher__body">
          <h2 class="mbr-voucher__title">{{ rewardDetail.reward_title }}</h2>
          <span v-if="rewardDetail.expiry_date_text" class="mbr-voucher__expiry">
            <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="10" /><path stroke-linecap="round" d="M12 6v6l4 2" /></svg>
            <span>{{ $t('voucher.expires', { date: rewardDetail.expiry_date_text }) }}</span>
          </span>

          <section class="mbr-voucher__card mbr-voucher__card--code">
            <div v-if="isShowQr" class="mbr-voucher__qr">
              <VueQRCodeComponent
                :text="rewardDetail.code"
                size="192"
                :color="qrColor"
                bg-color="#ffffff"
                error-level="L"
                class="d-flex justify-content-center"
              />
            </div>
            <span class="mbr-voucher__caps">{{ $t('voucher.voucher_code') }}</span>
            <div class="mbr-voucher__code">
              <input
                ref="codeInput"
                type="text"
                class="js-copytextarea mbr-voucher__code-value"
                :value="rewardDetail.code"
                readonly
              />
              <button
                type="button"
                class="mbr-voucher__copy"
                :aria-label="copied ? $t('voucher.code_copied') : $t('voucher.copy_code')"
                @click="coppyCode()"
              >
                <svg v-if="copied" fill="none" stroke="currentColor" stroke-width="2.4" viewBox="0 0 24 24" aria-hidden="true"><polyline points="20 6 9 17 4 12" /></svg>
                <svg v-else fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" /></svg>
              </button>
            </div>
            <p class="mbr-voucher__hint">{{ $t('voucher.show_screen_hint') }}</p>
          </section>

          <section v-if="hasApplicability" class="mbr-voucher__card">
            <h3 class="mbr-voucher__heading">{{ $t('voucher.applicable_for') }}</h3>
            <div class="mbr-voucher__rows">
              <div v-if="rewardDetail.tier_can_exchange_text" class="mbr-voucher__row">
                <span class="mbr-voucher__icon" aria-hidden="true">
                  <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>
                </span>
                <p>{{ rewardDetail.tier_can_exchange_text }}</p>
              </div>
              <div v-if="rewardDetail.branch_can_exchange_text" class="mbr-voucher__row">
                <span class="mbr-voucher__icon" aria-hidden="true">
                  <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" /></svg>
                </span>
                <p>{{ rewardDetail.branch_can_exchange_text }}</p>
              </div>
              <div v-if="rewardDetail.item_apply_text" class="mbr-voucher__row">
                <span class="mbr-voucher__icon" aria-hidden="true">
                  <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" /></svg>
                </span>
                <p>{{ rewardDetail.item_apply_text }}</p>
              </div>
              <div v-if="rewardDetail.order_minimum_text" class="mbr-voucher__row">
                <span class="mbr-voucher__icon" aria-hidden="true">
                  <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                </span>
                <p>{{ rewardDetail.order_minimum_text }}</p>
              </div>
            </div>
          </section>

          <section v-if="terms.length > 0" class="mbr-voucher__card">
            <h3 class="mbr-voucher__heading">{{ $t('reward.terms_conditions') }}</h3>
            <ul class="mbr-voucher__terms">
              <li v-for="(value, index) in terms" :key="index">{{ value }}</li>
            </ul>
          </section>

          <section v-if="rewardDetail.where_to_use" class="mbr-voucher__card">
            <h3 class="mbr-voucher__heading">{{ $t('voucher.where_to_use') }}</h3>
            <div class="mbr-voucher__where" v-html="rewardDetail.where_to_use"></div>
          </section>
        </div>
      </div>
    </div>
    <button
      class="btn-qrcode-modal"
      style="display: none"
      data-bs-toggle="modal"
      data-bs-target="#qrcode-modal"
    >
      Success
    </button>
  </div>
</template>

<script>
import VueQRCodeComponent from 'vue-qrcode-component'
import { themeTokenValue } from '@/config/themeColor'
export default {
  name: "QrcodeReward",
  components: {
    VueQRCodeComponent
  },
  props: {
    rewardDetail: {
      type: Object,
      default() {
        return {
        }
      }
    },
    merchantMember: {
      type: Object,
      default() {
        return {
        }
      }
    },
    isShowQr: {
      type: Boolean,
      default() {
        return true
      }
    },
    processAcction: {
      type: Function,
      default: () => { },
    },
  },
  data() {
    return {
      copied: false,
      copiedTimer: null,
      qrColor: themeTokenValue('--mbr-color-qr', '#3A0F0F'),
    }
  },
  computed: {
    // the backend sends full sentences, one per rule; drop the card when none apply
    hasApplicability() {
      return Boolean(
        this.rewardDetail.tier_can_exchange_text ||
        this.rewardDetail.branch_can_exchange_text ||
        this.rewardDetail.item_apply_text ||
        this.rewardDetail.order_minimum_text
      )
    },

    terms() {
      return (this.rewardDetail.terms_arr ?? []).filter(Boolean)
    },
  },
  beforeUnmount() {
    clearTimeout(this.copiedTimer)
  },
  methods: {
    coppyCode() {
      // via ref, not document/$el: MyCampaigns mounts a second sheet with the same
      // class, and this template has two roots so $el is only a fragment anchor
      const ipnElement = this.$refs.codeInput
      if (!ipnElement) {
        return
      }
      ipnElement.select()
      document.execCommand('copy')
      this.copied = true
      clearTimeout(this.copiedTimer)
      this.copiedTimer = setTimeout(() => {
        this.copied = false
      }, 1500)
    }
  }
};
</script>
<style scoped>
/* MBR035 voucher detail sheet — shell matches the member QR sheet (MBR024).
   Doubled with .modal.modal-bottom to outrank the square corners set below */
.modal.modal-bottom .modal-content.mbr-voucher {
  padding: 12px 20px 28px;
  background: var(--mbr-color-canvas);
  border: 0;
  border-top: 1px solid rgba(var(--mbr-color-outline-rgb), 0.5);
  border-radius: 32px 32px 0 0;
  box-shadow: var(--mbr-shadow-modal);
  font-family: var(--mbr-font-body);
  max-height: 92vh;
}

/* Store/RewardCatalogue load an unscoped `* { font-family: Poppins }` app-wide */
.mbr-voucher :where(:not(.material-icons-round)) {
  font-family: var(--mbr-font-body);
}

.mbr-voucher__top {
  position: relative;
  display: flex;
  justify-content: flex-end;
  min-height: 36px;
}

.mbr-voucher__handle {
  position: absolute;
  top: 0;
  left: 50%;
  width: 40px;
  height: 4px;
  background: var(--mbr-color-outline);
  border-radius: var(--mbr-radius-full);
  transform: translateX(-50%);
}

/* reset Bootstrap's .btn-close (svg background, 1em box, 50% opacity) */
.mbr-voucher__close.btn-close {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 36px;
  height: 36px;
  padding: 0;
  background: var(--mbr-color-tint) none;
  border: 1px solid rgba(var(--mbr-color-outline-rgb), 0.5);
  border-radius: var(--mbr-radius-full);
  color: var(--mbr-color-ink-secondary);
  opacity: 1;
  transition: transform 0.12s ease;
}

.mbr-voucher__close.btn-close:active {
  transform: scale(0.95);
}

.mbr-voucher__close.btn-close:focus-visible {
  outline: 2px solid var(--mbr-color-primary);
  outline-offset: 2px;
  box-shadow: none;
}

.mbr-voucher__close svg {
  width: 16px;
  height: 16px;
}

.mbr-voucher__body {
  display: flex;
  flex-direction: column;
  gap: 14px;
  align-items: stretch;
  padding-top: 4px;
}

/* font-family/color set explicitly: Material Dashboard forces Roboto Slab on h1-h3 */
.mbr-voucher__title {
  margin: 0;
  font-family: var(--mbr-font-headline);
  font-size: 24px;
  font-weight: 800;
  line-height: 30px;
  letter-spacing: -0.02em;
  color: var(--mbr-color-ink-headline);
}

.mbr-voucher__expiry {
  display: inline-flex;
  align-self: flex-start;
  align-items: center;
  gap: 6px;
  margin-top: -6px;
  padding: 4px 12px;
  background: var(--mbr-color-tint-dark);
  border-radius: var(--mbr-radius-full);
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  color: var(--mbr-color-ink-secondary);
}

.mbr-voucher__expiry svg {
  flex: none;
  width: 14px;
  height: 14px;
  color: var(--mbr-color-primary);
}

.mbr-voucher__card {
  padding: 18px;
  background: var(--mbr-color-surface);
  border: 1px solid rgba(var(--mbr-color-outline-rgb), 0.5);
  border-radius: var(--mbr-radius-xl);
  box-shadow: var(--mbr-shadow-card);
}

.mbr-voucher__card--code {
  text-align: center;
}

.mbr-voucher__qr {
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
}

.mbr-voucher__caps {
  display: block;
  font-family: var(--mbr-font-headline);
  font-size: 11px;
  font-weight: 700;
  line-height: 14px;
  letter-spacing: 0.1em;
  color: var(--mbr-color-ink-muted);
  text-transform: uppercase;
}

.mbr-voucher__code {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
  padding: 10px 10px 10px 14px;
  background: var(--mbr-color-canvas);
  border: 1px dashed rgba(var(--mbr-color-primary-rgb), 0.3);
  border-radius: var(--mbr-radius-md);
}

/* outranks the global .form-control rules; the input stays focusable so copy works */
.mbr-voucher__code-value {
  flex: 1 1 auto;
  width: 100%;
  min-width: 0;
  padding: 0;
  background: none;
  border: 0;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.12em;
  color: var(--mbr-color-primary);
  text-align: left;
}

.mbr-voucher__code-value:focus {
  outline: none;
}

.mbr-voucher__copy {
  display: flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  padding: 0;
  background: var(--mbr-color-tint);
  border: 0;
  border-radius: var(--mbr-radius-full);
  color: var(--mbr-color-primary);
  transition: transform 0.12s ease;
}

.mbr-voucher__copy:active {
  transform: scale(0.95);
}

.mbr-voucher__copy svg {
  width: 18px;
  height: 18px;
}

.mbr-voucher__hint {
  margin: 12px 0 0;
  font-size: 12px;
  font-weight: 500;
  line-height: 17px;
  color: var(--mbr-color-ink-secondary);
}

.mbr-voucher__heading {
  margin: 0;
  font-family: var(--mbr-font-headline);
  font-size: 14px;
  font-weight: 800;
  line-height: 20px;
  letter-spacing: normal;
  color: var(--mbr-color-ink-headline);
}

.mbr-voucher__rows {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 14px;
}

.mbr-voucher__row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.mbr-voucher__row p {
  margin: 0;
  font-size: 13px;
  font-weight: 500;
  line-height: 19px;
  color: var(--mbr-color-ink-secondary);
}

.mbr-voucher__icon {
  display: flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: var(--mbr-color-peach);
  border-radius: var(--mbr-radius-full);
  color: var(--mbr-color-primary);
}

.mbr-voucher__icon svg {
  width: 16px;
  height: 16px;
}

.mbr-voucher__terms {
  margin: 12px 0 0;
  padding: 12px 0 0 18px;
  border-top: 1px solid var(--mbr-color-tint-dark);
  list-style: disc;
}

.mbr-voucher__terms li {
  margin-top: 8px;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  color: var(--mbr-color-ink-secondary);
}

.mbr-voucher__terms li:first-child {
  margin-top: 0;
}

.mbr-voucher__where {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid var(--mbr-color-tint-dark);
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  color: var(--mbr-color-ink-secondary);
}

.mbr-voucher__where :deep(a) {
  color: var(--mbr-color-primary);
  text-decoration: underline;
}

.modal.modal-bottom .modal-content.mbr-voucher {
  overflow-y: auto;
}

/* Css model */
.modal.modal-left .modal-dialog,
.modal.modal-right .modal-dialog,
.modal.modal-top .modal-dialog,
.modal.modal-bottom .modal-dialog {
  -webkit-transform: translate3d(0%, 0, 0);
  -ms-transform: translate3d(0%, 0, 0);
  -o-transform: translate3d(0%, 0, 0);
  transform: translate3d(0%, 0, 0);
}

/* Left & Right */

.modal.modal-left .modal-dialog,
.modal.modal-right .modal-dialog {
  position: fixed;
  margin: auto;
  width: 500px;
  max-width: 100%;
  height: 100%;
}

.modal.modal-left .modal-content,
.modal.modal-right .modal-content {
  height: 100%;
  overflow-y: auto;
}

.modal.modal-left .modal-body,
.modal.modal-right .modal-body {
  padding: 15px 15px 80px;
}

.modal.modal-left.fade .modal-dialog {
  left: -500px;
  -webkit-transition: opacity 0.3s linear, left 0.3s ease-out;
  -moz-transition: opacity 0.3s linear, left 0.3s ease-out;
  -o-transition: opacity 0.3s linear, left 0.3s ease-out;
  transition: opacity 0.3s linear, left 0.3s ease-out;
}

.modal.modal-left.fade.show .modal-dialog {
  left: 0;
}

.modal.modal-right.fade .modal-dialog {
  right: -500px;
  -webkit-transition: opacity 0.3s linear, right 0.3s ease-out;
  -moz-transition: opacity 0.3s linear, right 0.3s ease-out;
  -o-transition: opacity 0.3s linear, right 0.3s ease-out;
  transition: opacity 0.3s linear, right 0.3s ease-out;
}

.modal.modal-right.fade.show .modal-dialog {
  right: 0;
}

.modal.modal-left .modal-content,
.modal.modal-right .modal-content,
.modal.modal-top .modal-content,
.modal.modal-bottom .modal-content,
.modal.modal-full .modal-content {
  border-radius: 0;
  border: none;
}

.modal.modal-left .modal-dialog.modal-sm,
.modal.modal-right .modal-dialog.modal-sm {
  width: 300px;
}

.modal.modal-left .modal-dialog.modal-lg,
.modal.modal-right .modal-dialog.modal-lg {
  width: 800px;
}

.modal.modal-left .modal-dialog.modal-xl,
.modal.modal-right .modal-dialog.modal-xl {
  width: 1140px;
}

/* Top and Bottom */

.modal.modal-top .modal-dialog,
.modal.modal-bottom .modal-dialog {
  position: fixed;
  margin: auto;
  width: 100%;
  max-width: 100%;
  height: auto;
}

.modal.modal-top .modal-content,
.modal.modal-bottom .modal-content {
  height: auto;
  overflow-y: auto;
}

.modal.modal-top .modal-body,
.modal.modal-bottom .modal-body {
  padding: 15px 15px;
}

/* Top */

.modal.modal-top.fade .modal-dialog {
  top: -100%;
  -webkit-transition: opacity 0.3s linear, top 0.3s ease-out;
  -moz-transition: opacity 0.3s linear, top 0.3s ease-out;
  -o-transition: opacity 0.3s linear, top 0.3s ease-out;
  transition: opacity 0.3s linear, top 0.3s ease-out;
}

.modal.modal-top.fade.show .modal-dialog {
  top: 0;
}

/* Bottom */

.modal.modal-bottom.fade .modal-dialog {
  bottom: -100%;
  -webkit-transition: opacity 0.3s linear, bottom 0.3s ease-out;
  -moz-transition: opacity 0.3s linear, bottom 0.3s ease-out;
  -o-transition: opacity 0.3s linear, bottom 0.3s ease-out;
  transition: opacity 0.3s linear, bottom 0.3s ease-out;
}

.modal.modal-bottom.fade.show .modal-dialog {
  bottom: 0;
}

.modal.modal-bottom.fade .modal-dialog {
  bottom: -100%;
}

/* Full Screen */

.modal.modal-full .modal-dialog {
  position: fixed;
  margin: auto;
  width: 100%;
  max-width: 100%;
  height: 100%;
}

.modal.modal-full .modal-content {
  height: 100%;
  overflow-y: auto;
}

.modal.modal-full .close-modal {
  position: fixed;
  top: 0;
  right: 3rem;
}

/* Footer */

.modal-footer-fixed {
  position: fixed;
  bottom: 0;
  width: 100%;
  background: var(--mbr-color-surface);
  border-radius: 0;
}

/* XS */

.modal.modal-left.xs .modal-body,
.modal.modal-right.xs .modal-body {
  padding: 15px;
}
</style>
